import { useQuery, type UseQueryResult } from "@tanstack/react-query"
import type { Questionnaire } from "fhir/r3"

type FetchQuestionnaireParams = {
  questionnaireId?: string
  odsId?: string
  token?: string | null
}

export async function fetchQuestionnaire({
  odsId,
  questionnaireId,
  token,
}: FetchQuestionnaireParams): Promise<Questionnaire> {
  const response = await fetch(`/api/healthcareservice/${odsId}/questionnaire/${questionnaireId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (response.ok) {
    const questionnaire = (await response.json()) as Questionnaire
    return questionnaire
  }

  throw Error("questionnaire service fetch failed")
}

export const useQuestionnaireQuery = ({
  odsId,
  questionnaireId,
  token,
}: FetchQuestionnaireParams): UseQueryResult<Questionnaire> =>
  useQuery({
    queryKey: ["questionnaire", questionnaireId],
    queryFn: async () => await fetchQuestionnaire({ odsId, questionnaireId, token }),
    enabled: !!token,
  })
